import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {OrderManager} from '../../data/manager/order/order/order.manager';
import {CustomerManager} from '../../data/manager/customer/customer/customer.manager';

@Injectable({
  providedIn: 'root',
})
export class QualifyOrderVm {
  constructor(private orderManager: OrderManager,
              private customerManager: CustomerManager) { }

  getRatings(): Observable<any> {
    return this.orderManager.getRatings();
  }

  putQualifyService(data): Observable<any> {
    return this.orderManager.putQualifyService(data);
  }

  getOrder(data): Observable<any> {
    return this.orderManager.getOrder(data);
  }

  hasCustomer() {
    return this.customerManager.hasValidCustomer();
  }

  setReviewLastOrderId(orderId: string) {
    return this.orderManager.setReviewLastOrderId(orderId);
  }
}
